import script from "./legoCheckboxWrapperExtend.vue?vue&type=script&lang=js"
export * from "./legoCheckboxWrapperExtend.vue?vue&type=script&lang=js"

import "./legoCheckboxWrapperExtend.vue?vue&type=style&index=0&id=710d4982&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-710d4982"],['__file',"src/components/lego/extend/legoCheckboxWrapperExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "710d4982"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('710d4982', __exports__)) {
    api.reload('710d4982', __exports__)
  }
  
}


export default __exports__